<template>
  <div>
    <v-list :flat="flat">
      <v-list-item-group
        v-model="workplace"
        :multiple="actionType === 'checkbox' ? true : false"
        :mandatory="actionType === 'select' ? true : false"
      >
        <template v-for="(item, index) in filteredWp">
          <v-divider :key="`divider-${index}`" v-if="index != 0"></v-divider>

          <v-list-item
            :key="`item-${index}`"
            @click="$emit('item-clicked', item)"
            :value="item.id"
          >
            <v-list-item-icon v-if="icon">
              <v-icon>{{ icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="height-large" :class="icon ? 'ml-4' : ''">
              <v-list-item-title v-html="item.name"></v-list-item-title>
              <v-list-item-subtitle
                >{{ item.postalAddress1 }}, {{ item.postalZip | formatZip}}
                {{ item.postalCity | uppercase }}
                <span v-if="withApprenticesQty">({{ item.numApprenticeships }})</span>
                <slot name="custom-text" v-bind="item"></slot>
              </v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-icon v-if="actionIcon">
              <div v-if="withExplanation" class="workplace-icons">
                <v-list-item-icon class="mr-n2" v-if="item.isDeliveryWorkplace">
                  <v-icon>$sl-delivery</v-icon>
                </v-list-item-icon>
                <v-list-item-icon v-if="item.isInvoiceWorkplace">
                  <v-icon>$sl-invoice</v-icon>
                </v-list-item-icon>
              </div>

              <v-icon
                v-if="isAdministrator || isDepartmentAdministrator($route.params.id)"
                >{{ actionIcon }}</v-icon
              >
            </v-list-item-icon>
            <v-list-item-icon v-if="actionType === 'checkbox'">
              <v-checkbox v-model="workplace" :value="item.id"> </v-checkbox>
            </v-list-item-icon>
            <v-list-item-action v-if="actionType === 'select'">
              <div class="v-list-item__radio">
                <input type="radio" v-model="workplace" :value="item.id" />
                <div class="check">
                  <div class="inside"></div>
                </div>
              </div>
            </v-list-item-action>
          </v-list-item>
        </template>
      </v-list-item-group>
    </v-list>
    <div v-if="withExplanation" class="mt-5 workplaces__icons--explanation">
      <p class="overline small">{{ $t("company.legend") }}</p>
      <p class="caption mt-n2">
        <v-icon class="mr-2">$sl-invoice</v-icon
        >{{ $t("application.company.text-invoice") }}
      </p>
      <p class="caption mt-n4">
        <v-icon class="mr-2">$sl-delivery</v-icon
        >{{ $t("application.company.text-delivery") }}
      </p>
      <p class="caption mt-n1" style="margin-left: 26px">
        {{ $t("application.company.text-apprentice") }}
      </p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import get from "lodash/get";

export default {
  name: "WorkplacesListItems",

  emits: ["item-clicked"],

  props: {
    filteredWp: {
      type: Array,
      required: true,
    },
    model: {
      type: [Array, Number],
      required: false,
    },
    actionType: {
      type: String,
      required: false,
    },
    isEditable: {
      // `true` / `false`
      type: Boolean,
      // The default value is: `true`
      default: true,
    },
    withApprenticesQty: {
      type: Boolean,
      required: false,
      default: false,
    },
    withSearch: {
      type: Boolean,
      required: false,
      default: false,
    },
    withExplanation: {
      type: Boolean,
      required: false,
      default: false,
    },
    flat: {
      type: Boolean,
      required: false,
      default: false,
    },
    icon: {
      type: String,
      required: false,
    },
  },

  data: function () {
    return {
      hasDepartments: true,
      tab: null,
      workplace: null
    };
  },

  watch: {
    model() {
      this.workplace = this.model
    },
  },

  computed: {
    ...mapGetters("currentuser", [
      "currentUser",
      "isAdministrator",
      "isAdminUser",
      "isDepartmentAdministrator",
    ]),

    actionIcon() {
      switch (this.actionType) {
        case "view":
          return "$sl-arrow-right";
        case "unlink":
          return "$sl-unlink";
        case "checkbox":
        case "select":
        default:
          return null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.workplace-icons {
  transform: scale(0.75);
  margin: 0;
  display: flex;
}
</style>
